import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { valueStack, valuePriced, valueTotals, offers, media } from '../data/product';
import { CtaButton } from './CtaButton';
import { GuaranteeBadge, ShopHotspot } from './BannerOverlays';
export function ValueStackSection() {
  return <section aria-labelledby="value-heading" className="border-b border-white/10 bg-ink-950" data-id="element-902" data-mp="1hcoy0f2grso2">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-903" data-mp="tn4arjza298z">
        <h2 id="value-heading" className="grit-headline max-w-3xl text-[clamp(2.25rem,8vw,4rem)] font-extrabold uppercase text-offwhite" data-id="element-904" data-mp="oojcvr7i01np">
          Do the math
          <br data-id="element-905" data-mp="12lzkv75g03hk" />
          <span className="text-grit-500" data-id="element-906" data-mp="ymz0hk7bgssg">on your old setup.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-steel-300" data-id="element-907" data-mp="yp3eiuyxj86g">
          A decent headlamp runs $40 to $60 and does nothing for your eyes. Work glasses and spare tints run more
          again, then the case and the anti-fog on top. The X1 is one piece of gear.
        </p>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-start" data-id="element-908" data-mp="1ncp2lxv7mzbf">
          <div className="border border-white/12 bg-ink-900" data-id="element-909" data-mp="1sai78mgv7l9l">
            <p className="border-b border-white/10 px-5 py-4 text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400 sm:px-6" data-id="element-910" data-mp="1wd55b544q2f8">
              Buy it all separately
            </p>
            <ul data-id="element-911" data-mp="14mquxivbr88b">
              {valuePriced.map(row => <li key={row.item} className="flex items-start justify-between gap-5 border-b border-white/5 px-5 py-4 sm:px-6" data-id="element-912" data-mp="14obop69ten54">
                  <span className="min-w-0" data-id="element-913" data-mp="1dmdoxjlq5brc">
                    <span className="block text-base font-semibold text-offwhite sm:text-lg" data-id="element-914" data-mp="1idvoc383n4a7">{row.item}</span>
                    <span className="mt-0.5 block text-[13px] text-steel-500" data-id="element-915" data-mp="kyrh1z5grkyo">{row.note}</span>
                  </span>
                  <span className="shrink-0 font-display text-2xl font-bold leading-none text-steel-300" data-id="element-916" data-mp="pwt1ooijfsc9">
                    {row.price}
                  </span>
                </li>)}
            </ul>

            <div className="flex items-center justify-between gap-5 border-b border-white/10 px-5 py-4 sm:px-6" data-id="element-917" data-mp="1o8m8298gminh">
              <span className="font-display text-xl font-bold uppercase tracking-wide text-steel-400" data-id="element-918" data-mp="220adxus48aw0">
                Buying it separately
              </span>
              <span className="font-display text-3xl font-extrabold leading-none text-steel-400 line-through" data-id="element-919" data-mp="1a8ulhk3vntxv">
                {valueTotals.total}
              </span>
            </div>
            <div className="flex items-center justify-between gap-5 border-b border-white/10 bg-ink-850 px-5 py-4 sm:px-6" data-id="element-920" data-mp="1ja2lq7pyf4ul">
              <span className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-921" data-mp="1ea6dtxe4yt9r">You save</span>
              <span className="font-display text-3xl font-extrabold leading-none text-grit-500" data-id="element-922" data-mp="2unwjv9otfrm1">
                {valueTotals.saveOne}
              </span>
            </div>

            <a href="#offer" className="group block bg-grit-500 px-5 py-6 text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-offwhite sm:px-6" data-id="element-923" data-mp="2y75efh6b9d3i">
              <p className="text-[11px] font-bold uppercase tracking-[0.2em]" data-id="element-924" data-mp="2t9dfw4b5usqc">You pay today</p>
              <p className="mt-2 flex flex-wrap items-end gap-x-4 gap-y-1" data-id="element-925" data-mp="3gyxz8ob87s05">
                <span className="font-display text-5xl font-extrabold leading-none sm:text-6xl" data-id="element-926" data-mp="3lxhl6optl3si">
                  {valueTotals.payOne}
                </span>
                <span className="pb-1.5 font-display text-lg font-bold uppercase sm:text-xl" data-id="element-927" data-mp="375z9v47wnxfh">
                  for one X1, everything included
                </span>
              </p>
              <p className="mt-3 font-display text-xl font-extrabold uppercase leading-tight sm:text-2xl" data-id="element-928" data-mp="3ps1wligje0w">
                Or {valueTotals.payEach} per X1 on the Full-Shift Kit.
              </p>
              <p className="mt-4 inline-flex items-center gap-2 font-display text-xl font-extrabold uppercase tracking-wide" data-id="element-929" data-mp="2g37nz2me79lk">
                Choose your pack
                <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-930" data-mp="270gbr0lp09sv" />
              </p>
            </a>
          </div>

          <div data-id="element-931" data-mp="2zoua5hgp184y">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-932" data-mp="2zrqblfrr2ey5">In every box</p>
            <ul className="mt-4 max-w-md" data-id="element-933" data-mp="2uswvrgozqbut">
              {valueStack.map(item => <li key={item} className="flex items-center gap-3 border-b border-white/10 py-3.5 text-base font-medium text-offwhite sm:text-lg" data-id="element-934" data-mp="2pxr7ib848l3k">
                  <CheckIcon className="h-5 w-5 shrink-0 text-grit-500" aria-hidden="true" data-id="element-935" data-mp="3ii7yv4ttcic4" />
                  {item}
                </li>)}
            </ul>

            <figure className="mt-8 border border-white/10 bg-ink-900" data-id="element-936" data-mp="3l1uriena8inm">
              <div className="relative" data-id="element-937" data-mp="3pyuq64hsyj4p">
                <img src={media.detailSheet} alt="The GritVue X1 frame with its light module, clear, amber and smoke lenses and USB-C charging" className="block h-auto w-full" data-id="element-938" data-mp="3pzwcj549qs1q" />
                <GuaranteeBadge compact box={{
                left: '17.2%',
                top: '37.4%',
                width: '17.4%',
                height: '9.2%'
              }} data-id="element-939" data-mp="7ukslmymd0nh" />
                <ShopHotspot box={{
                left: '3.3%',
                top: '38.4%',
                width: '14.2%',
                height: '7%'
              }} data-id="element-940" data-mp="cqrmghdqqlp2" />
              </div>
              <figcaption className="border-t border-white/10 px-4 py-3 text-[13px] text-steel-400" data-id="element-941" data-mp="mixm8da8i7et">
                The X1 itself: illuminated frame, all three lenses and USB-C charging.
              </figcaption>
            </figure>

            <ul className="mt-6 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-3" data-id="element-942" data-mp="vkne1k8138d4">
              {offers.map(offer => <li key={offer.id} data-id="element-943" data-mp="2skhwl8m7wqn9">
                  <a href="#offer" aria-label={`${offer.units} for ${offer.price}. Go to pricing`} className={`block h-full px-4 py-4 transition-[background-color,transform] duration-150 ease-grit active:translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500 ${offer.featured ? 'bg-grit-500 text-ink-950 hover:bg-grit-400' : 'bg-ink-900 hover:bg-ink-800'}`} data-id="element-944" data-mp="2nlf0wes4nwry">
                    <p className={`font-display text-2xl font-extrabold uppercase leading-none ${offer.featured ? 'text-ink-950' : 'text-offwhite'}`} data-id="element-945" data-mp="3kbxqzou0nho1">
                      {offer.units}
                    </p>
                    <p className={`mt-1 font-display text-3xl font-extrabold leading-none ${offer.featured ? 'text-ink-950' : 'text-grit-500'}`} data-id="element-946" data-mp="1lwbcxbygm4al">
                      {offer.price}
                    </p>
                    <p className={`mt-1 text-[11px] font-bold uppercase tracking-wide ${offer.featured ? 'text-ink-950/70' : 'text-steel-400'}`} data-id="element-947" data-mp="122l3szeegyh3">
                      {offer.perUnit ?? 'Single pack'}
                    </p>
                  </a>
                </li>)}
            </ul>

            <p className="grit-headline mt-8 text-[clamp(1.75rem,6vw,3rem)] font-extrabold uppercase text-offwhite" data-id="element-948" data-mp="j3gyo1pzboup">
              Three lenses.
              <br data-id="element-949" data-mp="o2trr47g1s5q" />
              One system.
              <br data-id="element-950" data-mp="2dhhu0cmbltq1" />
              <span className="text-grit-500" data-id="element-951" data-mp="2dgylfmik8hoo">One price.</span>
            </p>

            <CtaButton className="mt-6 w-full sm:w-auto" data-id="element-952" data-mp="2ig1hwikh5fl1">Get the Full-Shift Kit for $74.95</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}